import React from 'react';
import { PaginationControls, StickyBottom, styled, classes } from 'bonfire-kindling';

const StyledStickyBottom = styled(StickyBottom)(({ theme }) => ({
  [`& > .${classes.components.MuiBox.root}`]: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    [`& .${classes.components.MuiBox.root}:first-child`]: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  },
  [theme.breakpoints.up('sm')]: {
    width: `calc(100% - ${theme.widths.sideNav}px)`,
    marginLeft: `${theme.widths.sideNav}px`,
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
    height: 'auto',
  },
  backgroundColor: theme.palette.background.main,
}));

const DashboardDataTablePagination = ({ PaginationControlsProps, ...rest }) => (
  <StyledStickyBottom {...rest}>
    <PaginationControls {...PaginationControlsProps} />
  </StyledStickyBottom>
);

export default DashboardDataTablePagination;
